import { useState } from 'react';

const useInventoryFilters = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('active');
  const [selectedChannelId, setSelectedChannelId] = useState('');

  return {
    searchQuery,
    setSearchQuery,
    statusFilter,
    setStatusFilter,
    selectedChannelId,
    setSelectedChannelId,
  };
};

export default useInventoryFilters;
